import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import store from "./redux/store";
import { getPaymentProvider } from "@/utils/payment/paymentProvider";

const moment = require('moment-timezone');

moment.tz.setDefault("Europe/Moscow")

// На старте (любая страница) фиксируем провайдер эквайринга из ?provider=...
// в localStorage — иначе флаг с главной теряется при переходе в оплату.
getPaymentProvider();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);
